import { atom } from 'recoil'
import { recoilPersist } from 'recoil-persist'
const { persistAtom } = recoilPersist()

export const showTooltipsAtom = atom<boolean>({
  key: 'app/showTooltips',
  default: true,
  effects_UNSTABLE: [persistAtom],
});
